/* eslint-disable @typescript-eslint/ban-types */
import { NgZone } from '@angular/core';
import { getLifecyclePrototype } from './zone-decorators.util';

export const OutsideZone = (): ClassDecorator & MethodDecorator =>
    (constructor: Object | Function, propertyKey?: string | symbol, descriptor?: PropertyDescriptor) => {
        if (constructor && !propertyKey) {
            // Is Constructor.
            const prototype = getLifecyclePrototype(constructor as Function);

            for (const propertyName of Object.getOwnPropertyNames(prototype)) {
                const fnDescriptor = Object.getOwnPropertyDescriptor(prototype, propertyName);
                if (!fnDescriptor)
                    continue;

                const isMethod = fnDescriptor.value && fnDescriptor.value instanceof Function;
                if (!isMethod)
                    continue;

                const fnSource: Function = fnDescriptor.value;

                fnDescriptor.value = function (...data: any[]): any {
                    return Zone.root.run(() => fnSource.call(this, ...data));
                };

                Object.defineProperty(prototype, propertyName, fnDescriptor);
            }

            return constructor as any;
        }
        // Is Method.
        const source: Function = descriptor!.value;

        descriptor!.value = function (...data: any[]): Function {
            return Zone.root.run(() => source.apply(this, data));
        };

        return descriptor;
    };

export const InsideZone = (): MethodDecorator => {
    let zoneKey: string;

    return (_: Object, _propertyKey: string | symbol, descriptor: PropertyDescriptor) => {
        const source: Function = descriptor.value;

        descriptor.value = function (...data: any[]): Function {
            if (!zoneKey) {
                for (const k in this) {
                    if (!((this as any)[k] instanceof NgZone))
                        continue;

                    zoneKey = k;
                    break;
                }
            }

            if (!zoneKey)
                throw new Error('[InsideZone] Class with \'@InsideZone\' decorator should have a class property with \'NgZone\' class.');

            const zone: NgZone = (this as any)[zoneKey];
            return zone.run(() => source.call(this, ...data));
        };

        return descriptor;
    };
};